module.exports = __webpack_public_path__ + "static/img/banner2.2e027d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/banner2.png
// module id = wndQ
// module chunks = 2